import { ActionReducerMap } from '@ngrx/store';
import { ContentsLibraryActionTypes , GetTagsSuccess, GetResourcesSuccess } from './actions';
import { Tag } from '@bidi/common-services';

export function tags(state  = {} , {type , payload} : GetTagsSuccess){
    switch (type) {
        case ContentsLibraryActionTypes.GET_TAGS_SUCCESS:
            const newState = {...state};
            payload.forEach(element => {
                if(newState[element.type])
                    newState[element.type].push(element)
                else    
                    newState[element.type] = [element]
            });
            return newState;
        default:
            return state;
    }
}

export function resources(state : any = [], {type, payload} : GetResourcesSuccess){    
    switch (type) {
        case ContentsLibraryActionTypes.GET_RESOURCES_SUCCESS:
            return payload
        default:
            return state    
    }
}

export function selectedTag(state : any = {}, {type, payload}){    
    switch (type) {
        case ContentsLibraryActionTypes.SELECTED_TAG:
            return payload
        default:
            return state    
    }
}

export interface State {
    tags : {
        [type : string]:Tag[]
    };
    resources : {
        
    };
    selectedTag : any
}

export const reducers: ActionReducerMap<State> = {
    tags,
    resources,
    selectedTag
};